module.exports = __webpack_public_path__ + "static/media/endEvent.9e6c0d79.svg";